import { createActionGroup, props } from '@ngrx/store';
import { Floor, MutateFloor } from '@era/locations-sdk';
import { ErrorModel } from '@era/app';

// ============================================================================
// FLOOR ACTIONS
// ============================================================================
// Note: We will step away from using these actions in the future, so don't
// add new ones or build upon them.
// ============================================================================

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const FloorResolverActions = createActionGroup({
  source: 'Floor Resolver',
  events: {
    'Floors Requested': props<{ brandId: string; locationId: string }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const FloorSignalRHubActions = createActionGroup({
  source: 'Floor SignalR Hub',
  events: {
    'Floor Updated': props<{ floor: Floor }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const FloorApiActions = createActionGroup({
  source: 'Floors API',
  events: {
    'Floors Loaded': props<{ floors: Floor[] }>(),
    'Floors Loaded error': props<{ error: ErrorModel }>(),
    'Floor Added': props<{ floor: Floor }>(),
    'Floor Added error': props<{ floor: Floor; error: ErrorModel }>(),
    'Floor Updated': props<{ floor: Floor }>(),
    'Floor Updated error': props<{ floor: Floor; error: ErrorModel }>(),
    'Floor Deleted': props<{ floor: Floor }>(),
    'Floor Deleted error': props<{ floor: Floor; error: ErrorModel }>(),
  },
});

// ============================================================================
// LIST ACTIONS (Group - using createActionGroup)
// ============================================================================

export const FloorListActions = createActionGroup({
  source: 'Floor list',
  events: {
    'Floor Added': props<{ brandId: string; locationId: string; floor: MutateFloor }>(),
    'Floor Updated': props<{ originalFloor: Floor; floor: Floor }>(),
    'Floor Deleted': props<{ floor: Floor }>(),
  },
});
